import React, { SVGAttributes } from 'react';

export function LightningIcon(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg width='12' height='22' viewBox='0 0 12 22' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.1254 10.3494C11.2148 10.2041 11.2638 10.0376 11.2674 9.86701C11.271 9.69645 11.229 9.52803 11.1458 9.37911C11.0626 9.23018 10.9412 9.10614 10.794 9.01978C10.6469 8.93342 10.4794 8.88787 10.3088 8.88781H7.04916V0.450312L0.160411 11.6459C0.0709556 11.7912 0.0218897 11.9576 0.0182809 12.1282C0.0146721 12.2987 0.0566512 12.4671 0.139883 12.616C0.223115 12.7649 0.344582 12.8888 0.491738 12.9751C0.638895 13.0613 0.806407 13.1067 0.976974 13.1066H4.23666V21.5441L11.1254 10.3494Z'
        fill='white'
      />
    </svg>
  );
}
